<template>
  <v-container id="descuento" tag="section">
    <base-v-component heading="Promociones " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="nombre"
                label="Nombre"
                @input="$v.nombre.$touch()"
                @blur="$v.nombre.$touch()"
                :error-messages="nombreErrors"
                ref="nombreReferencia"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="descripcion" label="Descripción">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="tiposDescuentos"
                label="Tipo"
                :error-messages="tipoErrors"
                v-model="tipo"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                multiple
                label="Permitir en"
                :items="$store.state.descuentos.restriccionModo"
                v-model="restriccionModo"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="Modalidad"
                :items="$store.state.descuentos.modalidadDescuentosSelect"
                v-model="modalidad"
              />
            </v-col>
            <v-col cols="12" md="4" v-if="modalidad == 'porcentaje'">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="valorDescuento"
              />
            </v-col>
            <v-col cols="12" md="4" v-else-if="modalidad == 'absoluto'">
              <v-text-field
                label="Valor absoluto descuento"
                type="number"
                step="0.05"
                v-model="valorDescuento"
              />
            </v-col>
            <v-col cols="12" md="4" v-else-if="modalidad == 'promocion'">
              <v-select
                label="Promoción"
                :items="$store.state.descuentos.promocionSelect"
                v-model="valorDescuento"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                multiple
                label="Días de la semana"
                :items="diasSemanaDigito"
                v-model="diasSemana"
              />
            </v-col>
          </v-row>
          <v-row v-if="tipo == 'negocio'">
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeNegocio"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="tipo == 'carrito'">
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeCarrito"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="tipo == 'restaurante'">
            <v-col cols="4">
              <v-select
                label="Elige los restaurantes"
                v-model="restaurantesSelected"
                :items="restaurantes"
                multiple
              />
            </v-col>
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeRest"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="tipo == 'totem'">
            <v-col cols="4">
              <v-select
                label="Elige los totems"
                v-model="totemsSelected"
                :items="totems"
                multiple
              />
            </v-col>
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeRest"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="tipo == 'categoria'">
            <v-col cols="4">
              <v-select
                label="Elige las categorias"
                v-model="categoriasSelected"
                :items="categorias"
                multiple
              />
            </v-col>
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeCat"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="tipo == 'producto'">
            <v-col cols="4">
              <v-autocomplete
                label="Elige los productos"
                :items="productos"
                v-model="productosSelected"
                multiple
              />
            </v-col>
            <!-- <v-col cols="4">
              <v-select
                label="Porcentaje descuento"
                :items="porcentajesSelect"
                v-model="porcentajeProd"
              />
            </v-col> -->
          </v-row>
          <v-row v-if="itemsCondiciones.length > 0">
            <v-col cols="12"> <h5 class="text-subtitle">Condiciones</h5></v-col>
            <v-col cols="12" sm="4">
              <v-select
                :items="itemsCondiciones"
                label="Tipo condición"
                v-model="condicionTipo"
            /></v-col>
            <v-col cols="12" sm="4" v-if="!!condicionTipo">
              <v-text-field
                label="cantidad condición"
                step="0.5"
                type="number"
                v-model="condicionValor"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="save" :loading="loadingForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    nombre: { required, minLength: minLength(2) },
    tipo: { required },
  },
  data() {
    return {
      nombre: "",
      descripcion: "",
      categoriasSelected: [],
      productosSelected: [],
      restaurantesSelected: [],
      totemsSelected: [],

      condicionTipo: null,
      condicionValor: 0,
      restriccionModo: [],
      loadingForm: false,
      tipo: null,
      modalidad: null,
      valorDescuento: null,
      diasSemana: [],
    };
  },
  computed: {
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      tiposDescuentos: (state) => state.descuentos.tiposDescuentosSelect,
      descuentosArray: (state) => state.descuentos.descuentosArray,
      porcentajesSelect: (state) => state.descuentos.porcentajesSelect,
      itemsCondicionesBruto: (state) => state.descuentos.tiposCondicionesSelect,
    }),
    diasSemanaDigito() {
      return this.$store.state.negocios.diasSemana.map((d, i) => {
        return {
          text: d.text,
          value: i,
        };
      });
    },
    itemsCondiciones() {
      return this.itemsCondicionesBruto.filter((i) => {
        return i.tipos && Array.isArray(i.tipos) && i.tipos.includes(this.tipo);
      });
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      categorias: "categorias/getCategoriasSelect",
      productos: "productos/getProductosSelect",
      restaurantes: "restaurantes/getRestaurantesSelect",
      caracteristicas: "caracteristicas/getCaracteristicasSelectGrupo",
      totems: "totems/getTotemsSelect",
    }),
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre obligatorio.");
      !this.$v.nombre.minLength && errors.push("Nombre demasiado corto.");
      return errors;
    },
    tipoErrors() {
      const errors = [];
      if (!this.$v.tipo.$dirty) return errors;
      !this.$v.tipo.required && errors.push("Tipo obligatorio.");
      return errors;
    },
  },
  methods: {
    goListado() {
      let str = "/admin/gest/" + this.negocio.id + "/descuentos/";
      this.$router.push(str);
    },
    addDescuento() {
      var desc = {
        id: this.id,
        nombre: this.nombre,
        descripcion: this.descripcion,
        condicionTipo: this.condicionTipo,
        condicionValor: this.condicionValor,
        activo: true, //this.activo
        restriccionModo: this.restriccionModo, // dónde se aplica
        modalidad: this.modalidad, //porcentaje, valor abosluto, promoción
        valorDescuento: this.valorDescuento,
        diasSemana: this.diasSemana,
        tipo: this.tipo,
      };
      switch (this.tipo) {
        case "restaurante":
          desc.restaurantes = this.restaurantesSelected;
          break;
        case "totem":
          desc.totems = this.totemsSelected;
          break;
        case "categoria":
          desc.categorias = this.categoriasSelected;
          break;
        case "producto":
          desc.productos = this.productosSelected;
          break;
      }
      let _vm = this;
      return this.$store.dispatch("descuentos/addDescuento", desc).then(() => {
        _vm.goListado();
      });
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        this.addDescuento()
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Descuento añadido con éxito",
            });
          })
          .catch((error) => {
            console.log(error);
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar el producto",
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
          });
      }
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/descuentos/add";
      this.$router.push(str);
    },
  },
  created() {},
  mounted() {
    this.id = this.$route.params.idDescuento;
    if (this.id) {
      const found = this.descuentosArray.find((e) => e.id == this.id);
      if (found) {
        this.tipo = found.tipo;
        this.nombre = found.nombre;
        this.descripcion = found.descripcion ? found.descripcion : "";
        this.condicionTipo = found.condicionTipo ? found.condicionTipo : null;
        this.condicionValor = found.condicionValor ? found.condicionValor : 0;
        this.restriccionModo = found.restriccionModo
          ? found.restriccionModo
          : [];
        this.modalidad = found.modalidad ? found.modalidad : "porcentaje";
        this.valorDescuento = found.valorDescuento ? found.valorDescuento : "";
        this.diasSemana = found.diasSemana ? found.diasSemana : [];
        this.tipo = found.tipo;
        switch (this.tipo) {
          case "restaurante":
            this.restaurantesSelected = found.restaurantes;
            break;
          case "totem":
            this.totemsSelected = found.totems;
            break;
          case "categoria":
            this.categoriasSelected = found.categorias;
            break;
          case "producto":
            this.productosSelected = found.productos;
            break;
        }
      } else {
        this.goAdd();
      }
    }
  },
};
</script>

<style>
</style>